import ApiService from '@/services/api';

// TYPES
export type TRenameProjectResponse = unknown;
export type TRenameProjectMaterials = {
  name: string;
};

// FUNCTION
export const renameProject = async (
  companyId: number,
  projectId: number,
  requestBody: TRenameProjectMaterials,
): Promise<TRenameProjectResponse> => {
  const endpoint = `/v1/companies/${companyId}/projects/${projectId}/`;
  const response = await ApiService.put(endpoint, requestBody);
  return response;
};
